import React from 'react';
import { ArrowRight } from 'lucide-react';
import './Hero.css';
import { heroData } from '../mockData';

const Hero = ({ onSubscribe, onSamplePack }) => {
  const handleSubscribe = () => {
    const element = document.getElementById('subscription');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleSamplePack = () => {
    const element = document.getElementById('sample-pack');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="hero" className="hero-section">
      <div className="hero-content">
        <h1 className="hero-title">{heroData.headline}</h1>
        <p className="hero-subtitle">{heroData.subtext}</p>
        <div className="hero-actions">
          <button className="btn-primary" onClick={handleSubscribe}>
            Subscribe @ ₹999/month
            <ArrowRight size={20} />
          </button>
          <button className="btn-secondary" onClick={handleSamplePack}>
            Order Sample Pack
          </button>
        </div>
      </div>
      <div className="hero-trust">
        <div className="trust-badge">
          <span className="trust-text">🌱 100% Organic</span>
          <span className="trust-text">✓ Fresh Weekly</span>
          <span className="trust-text">📦 Free Delivery</span>
        </div>
      </div>
    </section>
  );
};

export default Hero;
